import { Formik } from "formik";
import React, { useState } from "react";
import { editPasswordCustomer } from "../../redux/action/customers";
import { useDispatch } from "react-redux";
import { ValidationEditCustomerPass } from "../../utills/Validation";
import hideIcon from "../../assets/images/hide.png";
import ViewIcon from "../../assets/images/view.png";

const EditCustomerPassword = ({ editDetails, modalId }) => {
  // console.log(editDetails, "editDetails");
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0 d-flex">
            <div className="text-center">
              <h1 className=" text-primary">
                {editDetails?.position == "user_admin"
                  ? "Change Admin Password"
                  : "Change Customer Password"}
              </h1>
            </div>
            <button
              type="button"
              id="closeBtn"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="modal-body p-0">
              <Formik
                initialValues={{
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={ValidationEditCustomerPass}
                enableReinitialize={true}
                onSubmit={(values, { resetForm }) => {
                  const payload = {
                    ...values,
                    id: editDetails?._id,
                  };
                  if (!editDetails?._id) return;
                  setBtnLoading(true);
                  resetForm();
                  dispatch(
                    editPasswordCustomer(payload, (type) => {
                      if (type === "success") {
                        setTimeout(() => {
                          setBtnLoading(false);
                          document?.getElementById("closeBtn").click();
                        }, 1500);
                      }
                      if (type === "error") {
                        setBtnLoading(false);
                      }
                    })
                  );
                }}
              >
                {({
                  errors,
                  touched,
                  values,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                }) => (
                  <form
                    id="customPassEdit"
                    className="form"
                    onSubmit={handleSubmit}
                  >
                    <div className="row mb-8">
                      <div className="col-xl-3">
                        <div className="fs-6 fw-bold mt-2 mb-3"><span className="required">Password</span></div>
                      </div>

                      <div className="col-xl-9 fv-row fv-plugins-icon-container input-group">
                        <input
                          type={!showPassword ? "password" : "text"}
                          className="form-control form-control-solid"
                          name="password"
                          id="passwordId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.password}
                        />
                        <div
                          className="btn btn-light"
                          onClick={togglePasswordVisibility}
                        >
                          <img
                            className="membership-badge ms-2"
                            src={showPassword ? ViewIcon : hideIcon}
                          />
                        </div>
                        <div className="fv-plugins-message-container invalid-feedback"></div>
                      </div>
                    </div>
                    {errors.password && touched.password ? (
                      <div className="text-danger fs-7">{errors.password}</div>
                    ) : null}
                    <div className="row mb-8">
                      <div className="col-xl-3">
                        <div className="fs-6 fw-bold mt-2 mb-3">
                          <span className="required">Confirm Password</span>
                        </div>
                      </div>
                      <div className="membership-form-check col-xl-9 fv-row fv-plugins-icon-container d-flex flex-wrap checkbox input-group">
                        <input
                          type={!showConfirmPassword ? "password" : "text"}
                          className="form-control form-control-solid"
                          name="confirmPassword"
                          id="confirmPasswordId"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values?.confirmPassword}
                        />
                        <div
                          className="btn btn-light"
                          onClick={toggleConfirmPasswordVisibility}
                        >
                          <img
                            className="membership-badge ms-2"
                            src={showConfirmPassword ? ViewIcon : hideIcon}
                          />
                        </div>
                      </div>
                    </div>
                    {errors.confirmPassword && touched.confirmPassword ? (
                      <div className="text-danger fs-7">
                        {errors.confirmPassword}
                      </div>
                    ) : null}
                    <div className="separator mb-6"></div>
                    <div className="d-flex justify-content-end">
                      <button
                        disabled={!btnLoading ? false : true}
                        type="submit"
                        className="btn btn-primary"
                      >
                        <span className="indicator-label">Save</span>
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomerPassword;
